import * as React from 'react'

const PngIcon = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  ({ ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="24"
      fill="none"
      viewBox="0 0 22 24"
      ref={ref}
      {...props}
    >
      <g clipPath="url(#clip0_7337_43631)">
        <path
          fill="#E9F0FA"
          d="m17 0 4 4v19a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z"
        ></path>
        <path fill="#C2CDDE" d="M21 4h-4V0z"></path>
      </g>
      <rect width="22" height="10" y="10" fill="#4881F1" rx="1"></rect>
      <path
        fill="#fff"
        d="M3.015 18v-5.818h2.182q.67 0 1.125.25.458.25.69.687.237.435.236.989 0 .56-.236.994-.236.435-.696.685-.46.247-1.133.247H3.737v-.866H5.04q.391 0 .642-.137a.86.86 0 0 0 .37-.375q.12-.239.121-.548 0-.31-.122-.546a.83.83 0 0 0-.372-.366q-.25-.133-.645-.133H4.07V18zm9.93-5.818V18h-.937l-2.742-3.963h-.048V18H8.164v-5.818h.943l2.739 3.966h.05v-3.966zm5.046 1.858a1.5 1.5 0 0 0-.196-.412 1.3 1.3 0 0 0-.295-.316 1.2 1.2 0 0 0-.392-.195 1.6 1.6 0 0 0-.483-.069q-.469 0-.836.236a1.6 1.6 0 0 0-.576.693q-.207.455-.208 1.108 0 .66.208 1.117.207.457.576.696.37.236.858.236.444 0 .767-.17.327-.172.503-.484a1.5 1.5 0 0 0 .176-.739l.239.037h-1.58v-.824h2.361v.7q0 .746-.318 1.292a2.17 2.17 0 0 1-.875.84 2.7 2.7 0 0 1-1.278.293q-.804 0-1.412-.36a2.5 2.5 0 0 1-.946-1.032q-.338-.67-.338-1.59 0-.705.199-1.259.202-.555.562-.94.36-.39.847-.591a2.7 2.7 0 0 1 1.056-.205q.483 0 .901.142.418.14.742.398.326.258.536.614.21.354.276.784z"
      ></path>
      <defs>
        <clipPath id="clip0_7337_43631">
          <path fill="#fff" d="M1 0h20v24H1z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
)

PngIcon.displayName = 'PngIcon'

export { PngIcon }
